import type { TimelineDesignTokens, TimelineTokenSections } from '@primeuix/themes/types/timeline';

export const event: TimelineTokenSections.Event = {
    minHeight: '5rem'
};

export const horizontal: TimelineTokenSections.Horizontal = {
    eventContent: {
        padding: '1rem'
    }
};

export const vertical: TimelineTokenSections.Vertical = {
    eventContent: {
        padding: '1rem'
    }
};

export const eventMarker: TimelineTokenSections.EventMarker = {
    size: '1.125rem',
    borderRadius: '{extend.borderRadius.rounded}',
    borderWidth: '0.25rem',
    background: '{content.background}',
    borderColor: '{content.borderColor}',
    content: {
        borderRadius: '{extend.borderRadius.rounded}',
        size: '0.375rem',
        background: '{primary.color}',
        insetShadow: 'none'
    }
};

export const eventConnector: TimelineTokenSections.EventConnector = {
    color: '{content.borderColor}',
    size: '0.125rem'
};

export default {
    event,
    horizontal,
    vertical,
    eventMarker,
    eventConnector
} satisfies TimelineDesignTokens;
